<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
         <v-row justify="space-between" align="center">
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in filteredItems" :key="index">
            <v-checkbox
              v-if="item.type === 'checkbox'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-checkbox>
            <v-text-field
              v-if="item.type === 'text'"
              v-model="clientInfo[item.key]"
              :label="item.text"></v-text-field>
          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  // @group EditClient
  // Client Tracking Settings tab for EditClientPage
  export default {
    name: "TrackingSettings",
    props: {
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {text: 'Enable Tracking', key: 'enable_tracking', type: 'checkbox'},
          {text: 'Enable POD Download', key: 'tracking_pod_download', type: 'checkbox'},
          {text: 'Force Doorstep Scan', key: 'require_scan', type: 'checkbox'},
          {text: 'CC Phone', key: 'tracking_contact_phone', type: 'text'},
          {text: 'CC Email', key: 'tracking_contact_email', type: 'text'}
        ]
      }
    },
    computed: {
      isAdmin() {
        return this.$store.getters['auth/isAdmin'];
      },
      filteredItems() {
        if (this.isAdmin) {
          return this.items;
        }
        return this.items.filter((item) => item.key !== "require_scan");
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/TrackingSettings.vue